import { styled } from '@mui/material/styles';
import { TreeItem as MuiTreeItem } from '@mui/x-tree-view';
import { ConfigEntryType } from 'config/config';
import RetroCategory from './RetroCategory';
import { Box, IconButton, Typography } from '@mui/material';
import { theme } from 'config/theme';
import ArrowDownSFillIcon from 'remixicon-react/ArrowDownSFillIcon';
import ArrowRightSFillIcon from 'remixicon-react/ArrowRightSFillIcon';

type RetroPhaseProps = {
  phase: ConfigEntryType;
  showCategoryTree: boolean;
};

function RetroPhase({ phase, showCategoryTree }: RetroPhaseProps) {
  return (
    <TreeItem
      nodeId={phase.id || phase.entryCode}
      expandIcon={
        <IconButton size="small">
          <ArrowRightSFillIcon size={22} color={theme.palette.custom.darkJungleGreen} />
        </IconButton>
      }
      collapseIcon={
        <IconButton size="small">
          <ArrowDownSFillIcon size={22} color={theme.palette.custom.darkJungleGreen} />
        </IconButton>
      }
      sx={{
        '& .MuiTreeItem-group': {
          ml: 0,
        },
      }}
      label={
        <>
          <TitleContainer>
            <Title
              sx={{
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              {phase?.entryDescription || phase.entryCode}
            </Title>
          </TitleContainer>
        </>
      }
    >
      {(phase?.entryValues || []).map((category) => (
        <RetroCategory
          key={category}
          category={category}
          phase={phase}
          showCategoryTree={showCategoryTree}
        />
      ))}
    </TreeItem>
  );
}

export const TreeItem = styled(MuiTreeItem)({
  '& .MuiTreeItem-content': {
    backgroundColor: 'transparent !important',
  },
  '& .MuiTreeItem-iconContainer': {
    marginRight: 8,
  },
});

export const TitleContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  marginRight: 8,
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  color: theme.palette.custom.tuna,
}));

export default RetroPhase;
